export const WINDEX_FOUND_HANDLE = 'windex_found';
export const WINDEX_NO_RESULT_HANDLE = 'windex_no_result';

export function isWindexStep(step) {
  const type = String(step?.type || step?.step_type || '')
    .trim()
    .toLowerCase();
  return !!(step?.is_windex_step || type === 'windex');
}

function optionalStepOrder(value) {
  if (value == null || value === '') return null;
  const order = Number(value);
  return Number.isFinite(order) ? order : null;
}

export function windexNoResultNextOrder(step) {
  return optionalStepOrder(step?.windex_no_result_next_step_order);
}

/** Omit blank field so the backend stores fees. */
export function windexFields(step = {}) {
  if (!isWindexStep(step)) {
    return {
      is_windex_step: false,
      windex_year: '',
      windex_field: '',
      windex_reply_template: '',
      windex_no_result_message: '',
      windex_no_result_next_step_order: null,
    };
  }
  const field = String(step.windex_field || '').trim();
  const fields = {
    is_windex_step: true,
    windex_year: String(step.windex_year || '')
      .trim()
      .slice(0, 32),
    windex_reply_template: step.windex_reply_template || '',
    windex_no_result_message: step.windex_no_result_message || '',
    windex_no_result_next_step_order: windexNoResultNextOrder(step),
  };
  if (field) fields.windex_field = field;
  return fields;
}

export function validateWindexStep(step) {
  if (!isWindexStep(step)) return { ok: true };
  const year = String(step.windex_year || '').trim();
  if (!year || year.length > 32) {
    return { ok: false, error: 'Enter the academic year.' };
  }
  if (!String(step.windex_reply_template || '').trim()) {
    return { ok: false, error: 'Enter the reply template.' };
  }
  return { ok: true };
}

export const WINDEX_FEE_PLACEHOLDERS = [
  'StudentName',
  'PendingFee',
  'StandardName',
  'Class',
  'SectionName',
  'RollNo',
  'TotalYearlyFee',
  'TotalPaidFee',
  'TotalDiscount',
];
